export const FILE_UPLOAD = {
  name: '上传文件',
  api: '${BASE}/bcp-basic-data-dev/api/B/file/upload',
  method: 'post',
  doc: 'http://192.168.15.26:8180/rtmap-app/doc.html#486ff31af6a91af58c3446d44dcaa828',
};

export const TASK_ADD = {
  name: '创建任务',
  api: '${BASE}/bcp-apps/api/B/task/create',
  method: 'post',
  doc: 'http://192.168.15.26:8180/rtmap-app/doc.html#aac8656a12b5b6ad443fe9afea2f18c0',
};

export const TASK_LIST = {
  name: '任务列表',
  api: '${BASE}/bcp-apps/api/B/task/list',
  method: 'post',
  doc: 'http://192.168.15.26:8180/rtmap-app/doc.html#4168225ec00f0f87e833db700e9940bd',
};

export const TOKEN = {
  name: '获取token',
  api: 'http://center.beijingapm.top:8191/bcp-portal/api/B/user/login',
  method: 'post',
  doc: 'http://10.10.11.47:8090/pages/viewpage.action?pageId=17143570',
};

export const USERINFO = {
  name: '通过token获取用户信息',
  api: '${BASE}/bcp-apps/api/B/api/account/tenant/info',
  doc: 'http://10.10.10.10:8090/pages/viewpage.action?pageId=11928544',
};
export const ACCOUNT_ROLE_PERMISSION_TREE = {
  name: '通过账号查看对应的权限',
  api: '${BASE}/bcp-basic-data-dev/api/B/account/getAccountRolePermissionTree',
  doc: 'http://wiki.rt.com:8090/pages/viewpage.action?pageId=17143597',
};
export const HOME_USER_TREND = {
  name: '用户增长趋势',
  api: '${DATA}/ds-api/api/customer/trend',
  method: 'post',
  doc: 'http://192.168.15.56:8193/ds-api/doc.html#d729d030719c15876b6d5d42b817d5fa',
};

export const HOME_USER_TOTAL = {
  name: '用户总量',
  api: '${DATA}/ds-api/api/customer/count/total',
  doc: 'http://192.168.15.56:8193/ds-api/doc.html#b8d149c78dd74f378472746bd3592cda',
};

export const HOME_MARKETING_TREND = {
  name: '营销趋势',
  api: '${DATA}/ds-api/api/activity/ma/trend',
  method: 'post',
  doc: 'http://192.168.15.56:8193/ds-api/doc.html#f6559437e68dd1083b05534afa2bddce',
};

export const HOME_WARNING = {
  name: '预警通知列表',
  api: '${BASE}/bcp-apps/api/B/notice/list',
  doc: 'http://192.168.15.26:8180/rtmap-app/doc.html#21514a73fb4bafce315e0d11e8fa9281',
};

export const HOME_SHOP_JOINED = {
  name: '商户参与情况',
  api: '${DATA}/ds-api/api/activity/shop/participation',
  doc: 'http://192.168.15.56:8193/ds-api/doc.html#4dd8f1a17444600424dcf817f4e2049a',
};

export const HOME_COUPON_POPULAR = {
  name: '优惠券活跃情况',
  api: '${DATA}/ds-api/api/coupon/lively/list',
  method: 'post',
  doc: 'http://192.168.15.56:8193/ds-api/doc.html#975f79e4fae68f3cc8c5420b5e2b929f',
};

export const HOME_OPTIMIZATION = {
  name: '优化建议列表',
  api: '${BASE}/bcp-apps/api/B/suggestion/list',
  doc: 'http://192.168.15.26:8180/rtmap-app/doc.html#cf37083c38360d1a31f95bd2851bb4c2',
};

export const HOME_ACTIVITY_RANK = {
  name: '活动排行',
  api: '${DATA}/ds-api/api/activity/group/rank',
  method: 'post',
  doc: 'http://192.168.15.56:8193/ds-api/doc.html#bebd69e460312e89b7155e0e5938ad0c',
};

export const HOME_MEMBER_RADAR = {
  name: '会员表现力',
  api: '${DATA}/ds-api/api/customer/member/contribution',
  method: 'post',
  doc: 'http://192.168.15.56:8193/ds-api/doc.html#85e573bcc87d5994fca00b8c72155f85',
};

export const HOME_APP_RANK = {
  name: '应用排行',
  api: '${DATA}/ds-api/api/activity/app/rank',
  method: 'post',
  doc: 'http://192.168.15.56:8193/ds-api/doc.html#f117d2be2f9b8c350726ddd79b53ecb0',
};

export const HOME_CHANNEL_STATISTICS = {
  name: '会员来源排行-图表',
  api: '${DATA}/ds-api/api/channel/day/list',
  method: 'post',
  doc: 'http://192.168.15.56:8193/ds-api/doc.html#981713d9119540a255358dedbb5db58b',
};

export const HOME_CHANNEL_RANK = {
  name: '会员来源排行-列表',
  api: '${DATA}/ds-api/api/channel/ranklist',
  method: 'post',
  doc: 'http://192.168.15.56:8193/ds-api/doc.html#679e0d523d491c169ddb898d51ddb4fc',
};

export const HOME_COUPON_RANK = {
  name: '优惠券排行',
  api: '${DATA}/ds-api/api/coupon/ranklist',
  method: 'post',
  doc: 'http://192.168.15.56:8193/ds-api/doc.html#c7473524c99835ff49a345862e191315',
};

export const ACCOUNT_RELATION_LIST = {
  name: '获取主体列表',
  api: '${BASE}/bcp-basic-data-dev/api/B/accountRelationEntity/listDistinct',
  method: 'get',
};

export const GET_ZUKER_SYSTEMID = {
  name: '获取商户通系统Id',
  api: '${BASE}/bcp-basic-data-dev/api/B/dictType/getDictItemByCode',
  method: 'get',
};
export const PARENTACCOUNT_RELATION_LIST = {
  name: '获取父级主体列表',
  api: '${BASE}/bcp-basic-data-dev/api/B/businessEntityRelation/upBusinessEntityList',
  method: 'get',
};